const ApiAttributesKeys = {
  readingNameKey: 'readingName',
  freeQuestionCountKey: 'totalFreeQuestion',
  TotalQuestionCountKey: 'totalQuestion',
  chapterIdKey: 'chapterId',
  chapterNameKey: 'chapter_name', //* The key is associated with another table, which is why we cannot modify it.
  chapterOrderKey: 'chapter_order',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionReadingList/ApiAttributesKeys.js